import React from 'react';
import {ImageRaw} from '../../../../../components/image-raw';
import {Image} from '../../../../../components/image/image';
interface ArtistWithLightEffectProps {
    lightBeamsImage?: string;
    cloudEffectImage?: string;
    artistListImage?: string;
    concertLogoImage?: string;
}
const ArtistWithLightEffect: React.FC<ArtistWithLightEffectProps> = ({
    lightBeamsImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/light-beams.webp',
    cloudEffectImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/clound-background.png',
    artistListImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/heart-artist-group.webp',
    concertLogoImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-logo.webp',
}) => {
    //w-[375px] h-[225px]
    return (
        <div className="relative md:w-[600px] md:h-[360px] min-w-[375px] min-h-[225px]">
            <div className="absolute -top-[20%] left-0 h-full w-full">
                <ImageRaw
                    src={lightBeamsImage}
                    className="w-full h-full object-cover mix-blend-screen"
                    alt="image-light-beam"
                />
            </div>
            <div className="absolute top-0 left-0 h-full w-full">
                <ImageRaw
                    src={cloudEffectImage}
                    className="w-full h-full object-fill mix-blend-screen"
                    alt="image-cloud-effect"
                />
            </div>
            <div className="absolute top-0 left-0 h-full w-full z-10">
                <Image
                    src={artistListImage}
                    alt="Vươn Concert 2025 Artists"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="top"
                    className="mix-blend-lighten"
                />
                {/*<ImageRaw src={artistListImage} className="w-full h-full object-cover mix-blend-screen" alt="" />*/}
            </div>
            <div className="absolute top-[65%] left-1/2 transform -translate-x-1/2 h-1/2   w-1/2 z-10">
                <Image
                    src={concertLogoImage}
                    alt="Vươn Concert 2025 Logo"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="top"
                    className="mix-blend-lighten"
                />
            </div>
        </div>
    );
};

export default ArtistWithLightEffect;
